// @flow
export const HTTP_STATUS_200 = 200;
